module.exports = __webpack_public_path__ + "img/img-confirm-modal.png";